function onYouTubeIframeAPIReady() {
	YTplayer.apiLoaded = true;
}

var YTplayer = {
	$this : {
		hero : null,
	},
	apiLoaded : false,
	init: false,
	readyHero : function(event) {
		event.target.playVideo();
		// event.target.mute();
		event.target.getPlaybackQuality('hd1080');
		var id = $(event.target.getIframe()).attr('id');
		var $this = $('#' + id);
		if ( $this.closest('.owl-item').length > 0 ) {
			var $this = $('.owl-item.active #' + id );
		}

		$this.addClass('active');
	},
	stateChangeHero : function(event) {
		if (typeof event != 'undefined') {
			if (event.target.getPlayerState() == '0') {
				// console.log('ended');
				var start = $(event.target.getIframe()).attr('data-start');
				event.target.seekTo(start);
			}
			if (event.target.getPlayerState() == '1') {
				//console.log('playing');
			}
		}
	}
}

$.fn.youtube = function(options) {

	options = $.extend({
		option : false,
	}, options);

	var $container = $(this),
	prop = {
		active : false,
		player : false,
		$balk : null,
		$player : null,
		$hero : null
	}

	function initYoutubeApi() {
		YTplayer.init = true;
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	$.fn.youtube.initHero = function($this) {
		if ($this.length != '') {
			if (YTplayer.apiLoaded == false && YTplayer.init == false) {
				initYoutubeApi();
			}
			if (YTplayer.apiLoaded == true) {
				var id = $this.attr('data-youtube'),
						start =  $this.attr('data-start'),
						end = $this.attr('data-end');
				YTplayer.$this.hero = new YT.Player($this.attr('id'), {
					height: 'auto',
					width: 'auto',
					videoId: id,
					playerVars: {
						'controls': 1,
						'showinfo': 0,
						'start': start,
						'end': end,
						'rel': 0
					},
					events: {
						'onReady': YTplayer.readyHero,
						'onStateChange': YTplayer.stateChangeHero,
					}
				});
				prop.hero = true;
			} else {
				setTimeout(function() {
					$.fn.youtube.initHero($this);
				}, 100);
			}
		}
	}

	$.fn.youtube.initHero.play = function($this) {
		if ($this.length == 1 && prop.hero == true && YTplayer.apiLoaded == true && typeof YTplayer.$this.hero.pauseVideo === "function") {
			YTplayer.$this.hero.playVideo()
		}
	}

	$.fn.youtube.initHero.pause = function($this) {
		if ($this.length == 1 && prop.hero == true && YTplayer.apiLoaded == true && typeof YTplayer.$this.hero.pauseVideo === "function") {
			YTplayer.$this.hero.pauseVideo()
		}
	}

}
